import React, { useState, useEffect } from 'react';
import { Accordion, DatePickerCustom, InputLista, InputNumber, Modal } from '../../common';
import { PROCESO_STATE, useForm } from '@laramie/ui';
import { useUsuarios } from '../../hooks/useUsuarios';
import { object, func, bool } from 'prop-types';
import { CloneObject } from '../../../utils/helpers';
import { TIPS } from "../../../consts/tips";
import DataTaggerFormApi from '../DataTaggerFormApi';


const ProcesoModal = (props) => {

  const entityInit = {
    id: 0,
    identificador: "",
    entidad: "",
    idEntidad: 0,
    idProcesoProgramacion: 0,
    idEstadoProceso: 0,
    idCategoriaProceso: 0,
    idTipoProceso: 0,
    fechaProceso: null,
    fechaInicio: null,
    fechaFin: null,
    descripcion: "",
    observacion: "",
    avance: 0,
    origen: "",
    idUsuarioCreacion: "",
    fechaCreacion: null,
    urlEjecucion: "",
    temporal: false,
    cancelacionSolicitada: false,
    cancelable: false,
    pausable: false
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit
  });

  const [getNombreUsuario, resolveUsuarios] = useUsuarios({ key: 'ControlProcesos_UsuarioCache' });

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.proceso };
    });
    formSet({
      fechaProceso: props.proceso.fechaProceso
    });
    resolveUsuarios([props.proceso.idUsuarioCreacion]);
  }
  useEffect(mount, [props.proceso]);

  const [ formValues, formHandle, , formSet ] = useForm({
    fechaProceso: null
  });

  //handles
  const handleClickAceptar = () => {
    if (props.onConfirm) {
      let row = CloneObject(state.entity);
      row.idEstadoProceso = PROCESO_STATE.PENDIENTE;
      row.fechaProceso = formValues.fechaProceso;
      props.onConfirm(row);
    }
  };

  const handleClickCancel = () => {
    if (props.onCancel) {
      let row = CloneObject(state.entity);
      row.idEstadoProceso = PROCESO_STATE.CANCELADO;
      props.onCancel(row);
    }
  }

  return (
    <>

    <Modal
      size="xl"
      title={`Proceso: ${(state.entity.id > 0) ? state.entity.descripcion : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.PROCESO_MODAL}
      onEscape={() => props.onDismiss()}
      body={(<>
            <div className="row">

                <div className="mb-3 col-12 col-md-6">
                    <label htmlFor="descripcion" className="form-label">Descripción</label>
                    <input
                        name="descripcion"
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.descripcion }
                        disabled={true}
                    />
                </div>
                {(state.entity.id > 0) &&
                <>
                <div className="mb-3 col-12 col-md-3">
                    <label htmlFor="idEstadoProceso" className="form-label">Estado</label>
                    <InputLista
                        name="idEstadoProceso"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.idEstadoProceso }
                        lista="EstadoProceso"
                        disabled={true}
                    />
                </div>
                <div className="mb-3 col-12 col-md-3">
                    <label htmlFor="avance" className="form-label">Avance (%)</label>
                    <InputNumber
                        name="avance"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.avance }
                        precision={2}
                        disabled={true}
                    />
                </div>
                </>
                }
                <div className="mb-3 col-12 col-md-3">
                    <label htmlFor="idUsuarioCreacion" className="form-label">Usuario/a</label>
                    <input
                        name="idUsuarioCreacion"
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={ getNombreUsuario(state.entity.idUsuarioCreacion) }
                        disabled={true}
                    />
                </div>
                <div className="mb-3 col-6 col-md-3">
                    <label htmlFor="fechaProceso" className="form-label">Fecha programada</label>
                    <DatePickerCustom
                        name="fechaProceso"
                        placeholder=""
                        className="form-control"
                        value={ formValues.fechaProceso }
                        onChange={ formHandle }
                        time={true}
                        disabled={props.disabled || (state.entity.id > 0)}
                    />
                </div>
                {(state.entity.id > 0) &&
                <>
                <div className="mb-3 col-12 col-md-3">
                    <label htmlFor="fechaInicio" className="form-label">Fecha inicio</label>
                    <DatePickerCustom
                        name="fechaInicio"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.fechaInicio }
                        time={true}
                        disabled={true}
                    />
                </div>
                <div className="mb-3 col-12 col-md-3">
                    <label htmlFor="fechaFin" className="form-label">Fecha fin</label>
                    <DatePickerCustom
                        name="fechaFin"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.fechaFin }
                        time={true}
                        disabled={true}
                    />
                </div>
                <div className="mb-3 col-12">
                    <label htmlFor="observacion" className="form-label">Observación</label>
                    <input
                        name="observacion"
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={ state.entity.observacion }
                        disabled={true}
                    />
                </div>
                </>
                }
            </div>
            {props.showInfo &&
              <div className="mb-3 col-12">
                  <Accordion title="Información adicional" startOpen={true}>
                      <DataTaggerFormApi
                          title="Información adicional del proceso"
                          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_PROCESO_MODAL}
                          entidad="Proceso"
                          idEntidad={state.entity.id}
                          disabled={true}
                      />
                  </Accordion>
              </div>
          }
      </>)}
      footer={(
            <div className='footer-action-container'>
            {!props.disabled && (state.entity.id === 0) &&
              <button className="btn action-button float-end" data-dismiss="modal" onClick={ (event) => handleClickAceptar() } >Ingresar proceso</button>
            }
            {!props.disabled && state.entity.cancelable && (state.entity.idEstadoProceso === PROCESO_STATE.PENDIENTE || state.entity.idEstadoProceso === PROCESO_STATE.PROGRESO) &&
              <button className="btn action-button float-end" data-dismiss="modal" onClick={ (event) => handleClickCancel() } >Cancelar proceso</button>
            }
            {!props.disabled && state.entity.pausable && state.entity.idEstadoProceso === PROCESO_STATE.PROGRESO &&
              <button className="btn action-button float-end" data-dismiss="modal" onClick={ (event) => handleClickCancel() } >Pausar proceso</button>
            }
            <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
            </div>
      )}
    />

    </>
  );
}

ProcesoModal.propTypes = {
  disabled: bool,
  showInfo: bool,
  proceso: object.isRequired,
  onDismiss: func.isRequired,
  onConfirm: func,
  onCancel: func
};

ProcesoModal.defaultProps = {
  disabled: false,
  showInfo: false,
  onConfirm: null,
  onCancel: null
};

export default ProcesoModal;
